import { LocaleEnum } from '@unifyapps/i18n/const';

export const INTERFACE_LOCALES = [
  { const: LocaleEnum.Arabic, title: 'Arabic (العربية)' },
  { const: LocaleEnum.ArabicSaudiArabia, title: 'Arabic - Saudi Arabia (العربية - السعودية)' },
  { const: LocaleEnum.Assamese, title: 'Assamese (অসমীয়া)' },
  { const: LocaleEnum.Bengali, title: 'Bengali (বাংলা)' },
  { const: LocaleEnum.Bodo, title: 'Bodo (बड़ो)' },
  { const: LocaleEnum.Chinese, title: 'Chinese (中文)' },
  { const: LocaleEnum.Dogri, title: 'Dogri (डोगरी)' },
  { const: LocaleEnum.Dutch, title: 'Dutch (Nederlands)' },
  { const: LocaleEnum.EnglishUK, title: 'English (UK)' },
  { const: LocaleEnum.EnglishIndia, title: 'English (India)' },
  { const: LocaleEnum.English, title: 'English' },
  { const: LocaleEnum.Gujarati, title: 'Gujarati (ગુજરાતી)' },
  { const: LocaleEnum.Persian, title: 'Persian (فارسی)' },
  { const: LocaleEnum.French, title: 'French (Français)' },
  { const: LocaleEnum.German, title: 'German (Deutsch)' },
  { const: LocaleEnum.Greek, title: 'Greek (Ελληνικά)' },
  { const: LocaleEnum.Hebrew, title: 'Hebrew (עברית)' },
  { const: LocaleEnum.Hindi, title: 'Hindi (हिन्दी)' },
  { const: LocaleEnum.Hungarian, title: 'Hungarian (Magyar)' },
  { const: LocaleEnum.Italian, title: 'Italian (Italiano)' },
  { const: LocaleEnum.Japanese, title: 'Japanese (日本語)' },
  { const: LocaleEnum.Javanese, title: 'Javanese (Basa Jawa)' },
  { const: LocaleEnum.Kannada, title: 'Kannada (ಕನ್ನಡ)' },
  { const: LocaleEnum.Kashmiri, title: 'Kashmiri (كأشُر)' },
  { const: LocaleEnum.Konkani, title: 'Konkani (कोंकणी)' },
  { const: LocaleEnum.Korean, title: 'Korean (한국어)' },
  { const: LocaleEnum.Maithili, title: 'Maithili (मैथिली)' },
  { const: LocaleEnum.Malayalam, title: 'Malayalam (മലയാളം)' },
  { const: LocaleEnum.Manipuri, title: 'Manipuri (মৈতৈলোন্)' },
  { const: LocaleEnum.Marathi, title: 'Marathi (मराठी)' },
  { const: LocaleEnum.Nepali, title: 'Nepali (नेपाली)' },
  { const: LocaleEnum.Odia, title: 'Odia (ଓଡ଼ିଆ)' },
  { const: LocaleEnum.Punjabi, title: 'Punjabi (ਪੰਜਾਬੀ)' },
  { const: LocaleEnum.Polish, title: 'Polish (Polski)' },
  { const: LocaleEnum.Portuguese, title: 'Portuguese (Português)' },
  { const: LocaleEnum.Romanian, title: 'Romanian (Română)' },
  { const: LocaleEnum.Russian, title: 'Russian (Русский)' },
  { const: LocaleEnum.Sanskrit, title: 'Sanskrit (संस्कृतम्)' },
  { const: LocaleEnum.Santhali, title: 'Santhali (ᱥᱟᱱᱛᱟᱲᱤ)' },
  { const: LocaleEnum.Sindhi, title: 'Sindhi (سنڌي)' },
  { const: LocaleEnum.Spanish, title: 'Spanish (Español)' },
  { const: LocaleEnum.Tamil, title: 'Tamil (தமிழ்)' },
  { const: LocaleEnum.Telugu, title: 'Telugu (తెలుగు)' },
  { const: LocaleEnum.Turkish, title: 'Turkish (Türkçe)' },
  { const: LocaleEnum.Ukrainian, title: 'Ukrainian (Українська)' },
  { const: LocaleEnum.Urdu, title: 'Urdu (اردو)' },
  { const: LocaleEnum.Vietnamese, title: 'Vietnamese (Tiếng Việt)' },
];
